import { render, staticRenderFns } from "./Logement.vue?vue&type=template&id=ddc91d32&"
import script from "./Logement.vue?vue&type=script&lang=ts&"
export * from "./Logement.vue?vue&type=script&lang=ts&"
import style0 from "./Logement.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports